import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const Srchview = () => {
    const nav = useNavigate('');
    const [datak, setdata] = useState([]);
    const [end, setend] = useState(6)

    const [params] = useSearchParams();
    const query = params.get("srch");

    const getsrchData = async () => {
        const apikey = "cYaiLYjQHhOAt8grCTUUaiR9m2J83t0GD7T5YQI2zyKsI1TZuf0MX0tp";
        const app = await fetch(`https://api.pexels.com/v1/search?query=${query}&per_page=15`, {
            headers: { Authorization: apikey }
        })

    if (app) {
        let res = await app.json()
        setdata(res.photos)
    }
}

useEffect(() => {
    getsrchData();
}, [])

const more = () => {
    setend(end + 6)
}
useEffect(() => {
    getsrchData();
}, [end])

return (
    <>

        <div className="container">
            <div className="row">
                {
                    datak.slice(0, end).map((data, ind) => (
                        <>
                            <div key={ind} id="cardt" className="col-lg-4">
                                <div> <img onClick={() => nav(`/view?idtb=${data.id}`)} src={data.src.original} className="img-fluid" /> </div>
                            </div>

                        </>
                    ))}
            </div>
        </div>
        <div className="kload">
            <button className='btn btn-primary ' onClick={more}> View More </button>
        </div>
    </>

);
}

export default Srchview;